// utils/disableConsole.js
const disableConsole = () => {
  if (process.env.NODE_ENV === 'production') {
    console.log    = () => {};
    console.warn   = () => {};
    console.error  = () => {};
    console.info   = () => {};
    console.debug  = () => {};
    console.table  = () => {};
    console.group  = () => {};
    console.groupEnd = () => {};
  }
};

export default disableConsole;